// accedo sia al session storage che al localstorage per salvare le preferenze dell'utente.
// Questo permette di evitare il caso in cui l'utente, lavorando su due tab diverse con preferenze diverse,
// possa salvare delle preferenze in un tab e usarle nell'altro ricaricando la pagina.

/**
 * Proxy del localStorage e sessionStorage per gestire le preferenze utente.
 */
class Storage {
  storage = null;

  description = 'no storage';

  constructor(storage, description) {
    this.storage = storage;
    this.description = description;
  }

  getValue(key) {
    if (this.storage && this.storage.getItem(key) !== null) {
      return this.storage.getItem(key);
    }
    return null;
  }

  setValue(key, value) {
    if (this.storage) {
      this.storage.setItem(key, value);
    } else {
      console.warn(`Storage ${this.description} is not available in this environment.`);
    }
  }
}

/*
 * Accedo al valore prima per sessione, utilizzando il dato salvato nella sessione corrente,
 * e poi al local storage.
 *
 * Se lo trovo nel local storage, me lo salvo anche nel session in modo che sia fruibile dalla sessione
 * anche se altri tab sovrascrivo la preferenza globale.
 */
export function getValue(key) {
  let value = new Storage(window && window.sessionStorage, 'session').getValue(key);
  if (value !== null) {
    return value;
  }

  value = new Storage(window && window.localStorage, 'local').getValue(key);
  if (value !== null) {
    new Storage(window && window.sessionStorage, 'session').setValue(key, value);
    return value;
  }

  return null;
}

export function setValue(key, value) {
  new Storage(window && window.sessionStorage, 'session').setValue(key, value);
  new Storage(window && window.localStorage, 'local').setValue(key, value);
}
